import { useState } from "react";
import exitIcon from "../../../icons/exit.png";
import styles from "./GameExitButton.module.scss";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../components/Menu/MenuButton";
import { ActionsContext } from "../../ActionsPage/ACtionsRoutes";
import { ExitPopup } from "../../../components/Popup/ExitPopup/ExitPopup";

export const GameExitButton = () => {
    const [showExitPopup, setShowExitPopup] = useState(false);

    const navigate = useNavigate();

    const handleExitClick = () => setShowExitPopup(true);
    const handleCancelExit = () => setShowExitPopup(false);

    const handleClose = () => {
        navigate(`/${AppContext.Actions}/${ActionsContext.Games}`, { replace: true });
    };

    return (
        <>
            <button type="button" className={styles.exitButton} onClick={handleExitClick}>
                <img src={exitIcon} alt="" className={styles.exitIcon} />
                <span>Выйти</span>
            </button>

            {showExitPopup && (
                <ExitPopup
                    title="Вы уверены, что хотите выйти из игры?"
                    onClose={handleClose}
                    onCancel={handleCancelExit}
                />
            )}
        </>
    );
};
